import { render, staticRenderFns } from "./ProjectAnalyseAlternatives.vue?vue&type=template&id=01f1282a&scoped=true"
import script from "./ProjectAnalyseAlternatives.vue?vue&type=script&lang=js"
export * from "./ProjectAnalyseAlternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1282a",
  null
  
)

export default component.exports